import React from 'react';

type Props = {
	children: React.ReactNode;
	labelName: string;
	labelSize?: string;
	label?: boolean;
	fullWidth?: boolean;
	layout?: string;
}

function FieldSection({ children, labelName, label, labelSize, fullWidth, layout }: Props) {
	return (
		<section className={fullWidth ? `field-section full` : `field-section`}>
			<div className={`field ${layout}`}>
				{
					label !== false && (
						<label className={`label ${labelSize}`}>{labelName}</label>
					)
				}
				<div className={label === false ? 'cont full' : 'cont'}>
					{children}
				</div>
			</div>
		</section>
	)
}

FieldSection.defaultProps = {
	label: true,
	labelSize: 'large',
	fullWidth: false,
	layout: 'horizontal'
}


export default FieldSection;